import React from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { ToastContainer } from 'react-toastify';
import { theme as deeptrueTheme } from '@deeptrue-frontend/ui';
import { ThemeProvider as StyledThemeProvider } from 'styled-components/macro';
import 'react-toastify/dist/ReactToastify.css';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { SurveyGlobalStyles } from '@deeptrue-frontend/ui';
import SurveyContainer from './survey/survey';
import Homepage from './homepage/homepage';
import SurveyExternalSource from './survey/SurveyExternalSource';

const theme = createTheme({});

class App extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <StyledThemeProvider theme={deeptrueTheme}>
          <SurveyGlobalStyles />
          <Router>
            <ToastContainer />
            <Switch>
              <Route exact path="/" component={Homepage} />
              <Route
                exact
                path="/finished"
                render={() => <Homepage finished />}
              />
              <Route exact path="/:uuid" component={SurveyContainer} />
              <Route exact path="/test/:uuid" component={SurveyContainer} />
              <Route
                exact
                path="/public/:surveyUuid/"
                component={SurveyExternalSource}
              />

              <Redirect from="*" to="/" />
            </Switch>
          </Router>
        </StyledThemeProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;
